import { Box } from "@material-ui/core";
import { memo } from "react";

import styles from "../../ImageUploader.module.scss";
import { Image as ImageType, FileRemoveAction } from "../../types";
import { ImageProperties } from "../../utilities/FilesProperties";
import { localStorageNames } from "../../utilities/enums";
import { Compression } from "../Compression";
import { CorruptedFile } from "../CorruptedFile";
import { Image } from "../Image";
import PdfIcon from "../pdf/previewPdf.png";

type SinglePreviewProps = {
  readonly image: ImageType;
  readonly onFileRemove: FileRemoveAction;
  readonly readOnly?: boolean;
};

export const SinglePreview = memo<SinglePreviewProps>(
  ({ image, onFileRemove, readOnly = false }) => {
    const { isDuringCompression, isCorrupted, src } = image;
    /* LPPLWEBMOB-454 */
    let source: string = src;
    const imageProperties = new ImageProperties();
    imageProperties.CurrentImagePropertiesCheck();
    if (ImageProperties.ifPdf) {
      source = PdfIcon;
      //source = "../pdf/previewPdf.png";
    }
    imageProperties.incrementIndex();
    /* LPPLWEBMOB-454 END */
    return (
      <Box className={styles.wrapper}>
        {isCorrupted && <CorruptedFile onFileRemove={onFileRemove} />}
        {isDuringCompression && <Compression />}
        {source && (
          <Image
            src={source}
            isReadOnly={readOnly}
            onFileRemove={onFileRemove}
          />
        )}
      </Box>
    );
  }
);

export default SinglePreview;
